import { Component } from '@angular/core';

@Component({
    selector: 'open-support-ticket',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class OpenSupportTicketsComponent {}
